import $ from "jquery";

export const init = () => {
  const $header = $(".header");
  const $flyoutMenuSearch = $header.siblings(".flyout-search");
  const $searchBtn = $header.find(".btn--search"); //  || $header.find('.btn--burger-2')
  const $mainNav = $header.find(".main-nav");

  let isFlyoutHidden = true;
  let isWideScreen = window.innerWidth > 991;

  // Method to hide mobile flyout
  const hideMobileMainNav = function () {
    $mainNav.addClass("main-nav--hidding").removeClass("show");
    setTimeout(function () {
      $mainNav.removeClass("main-nav--hidding");
    }, 500);
  };

  /**
   * Utility method to hide flyout with CSS effect
   *
   * @param {Boolean} closeMenu - indicates that the main navigation should also be closed
   * (normally when clicked) outside of the flyout
   */
  const closeFlyoutMenuSearch = function (closeMenu = false) {
    if (isFlyoutHidden) return;

    $searchBtn.removeClass("active");
    $flyoutMenuSearch.removeClass("show").addClass("hiding");
    isFlyoutHidden = true;

    setTimeout(function () {
      $flyoutMenuSearch.removeClass("hiding");
    }, 400);

    if (closeMenu) hideMobileMainNav();
  };

  /**
   * Handles click event outside of flyout menu (backdrop)
   *
   * @param {Event} e - click event
   */
  const clickOutFlyoutHandler = function (e) {
    const targetElem = $(e.target);

    if (
      targetElem.closest($flyoutMenuSearch).length ||
      !$flyoutMenuSearch.find(".btn--back").length
    ) {
      return;
    }
    $searchBtn.removeClass("active");
    closeFlyoutMenuSearch(true);
    $("body").off("click", clickOutFlyoutHandler);
  };

  /**
   * Activates flyout menu considering screen orientation
   *
   * @param {JQuery} menu - Flout parent menu item
   */
  const showFlyoutMenuSearch = function (menu) {
    isFlyoutHidden = false;

    if (!isWideScreen) {
      $flyoutMenuSearch.addClass("show");
      menu.addClass("active");

      return;
    }

    if (!$flyoutMenuSearch.hasClass("show")) {
      $flyoutMenuSearch.addClass("show");
      $("body").on("click", clickOutFlyoutHandler);
    }

    // Do not complete operations if the same menu is opened
    if (menu.hasClass("active")) return;

    menu.siblings(".active").removeClass("active");
    menu.addClass("active");
  };

  /**
   * Dispatch flyout behaviour
   * when click event of the main navigation is fired
   *
   * @param {Event} e
   */
  const flyoutEventHandler = function (e) {
    const dataMenu = $(this).data("menu");

    // If no data-menu dataset, perform default action
    if (!dataMenu) return;

    // Close flyout in case of attempt to activate the same link
    if (
      e.type === "click" &&
      $(this).hasClass("active") &&
      $flyoutMenuSearch.hasClass("show")
    ) {
      $(this).removeAttr("style").removeClass("active");
      closeFlyoutMenuSearch();
      return;
    }

    // Activate a new item in main navigation
    $(this).siblings(".active").removeClass("active");
    $(this).addClass("active");

    // Activate needed flyout group
    const menu = $flyoutMenuSearch.find('[data-category="' + dataMenu + '"]');

    if (!menu.length) return;

    e.preventDefault();

    // Show flyout with category
    if (menu.length) {
      showFlyoutMenuSearch(menu, !isWideScreen);
    } else {
      console.warn(
        '%cMenu category "' + dataMenu + '" is not found in flyout.',
        warnStyle
      );
    }
  };
  $mainNav.find("li").on("click", flyoutEventHandler);

  // Resize event handler

  $(window).on("resize", function (e) {
    if (!e.isTrigger) {
      clearTimeout(this._sltimer);
      this._sltimer = setTimeout(() => {
        isWideScreen = window.innerWidth > 767;
        // console.log(
        //   "%cFlyout resize",
        //   "color:#919191;font-family:monospace;font-size:12px"
        // );
      }, 250);
    }
  });

  // Attach Flyout event handlers
  $flyoutMenuSearch.find(".btn--back").on("click", closeFlyoutMenuSearch);

  // Back to main menu on mobile
  $flyoutMenuSearch.find(".btn-back").on("click", function () {
    $flyoutMenuSearch
      .find(".flyout-search__category.active")
      .removeClass("active");
    $flyoutMenuSearch.removeClass("show");
  });

  $searchBtn.on("click", function (e) {
    e.preventDefault();

    if ($flyoutMenuSearch.hasClass("show")) {
      $searchBtn.removeClass("active");
      $flyoutMenuSearch.removeClass("show");
      isFlyoutHidden = true;
    } else {
      $flyoutMenuSearch.addClass("show");
      $searchBtn.addClass("active");
      isFlyoutHidden = false;
    }
  });
};
